module.exports = __webpack_public_path__ + "img/实验室通风系统2.b95d62ef.jpg";